import factoryFilterBox from './prosale-filter-box';

const { fetchQueryConditions, filterInfo, PROSALE_QUERYCONDITIONS_INFO } = factoryFilterBox();

export { fetchQueryConditions, PROSALE_QUERYCONDITIONS_INFO };

export default filterInfo;
